const routes = [
  {
    path: '/iam',
    name: 'iam',
    redirect: { name: 'client-keys' },
    component: () =>
      import(/* webpackChunkName: 'about' */ '@/views/iam/IamMain.vue'),

    children: [
      {
        path: 'client-keys',
        name: 'client-keys',
        component: () =>
          import(/* webpackChunkName: 'iam' */ '@/views/iam/IamClientKeys.vue')
      },

      {
        path: 'ip-whitelist',
        name: 'ip-whitelist',
        component: () =>
          import(/* webpackChunkName: 'iam' */ '@/views/iam/IpWhitelist.vue')
      }
    ]
  }
]

export default routes
